/* eslint-disable func-names */
/* eslint-disable no-undef */
const awardsDropdown = () => {
  (function ($) {
    const $button = $('.js-awards-dropdown__button');
    const $list = $('.js-awards-dropdown__list');
    const $buttonIcon = $('.c-awards__button-icon');

    const listOpenClass = 'js-awards-dropdown__list--open';
    const iconOpenClass = 'c-awards__button-icon--open';

    $button.on('click', () => {
      const isOpen = $list.hasClass(listOpenClass);

      if (isOpen) {
        $list.slideUp();
      } else {
        $list.slideDown();
      }
      $list.toggleClass(listOpenClass);
      $buttonIcon.toggleClass(iconOpenClass);
    });
  }(jQuery));
};

export default awardsDropdown;
